import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guard/auth-guard.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    canActivate: [AuthGuard],

    loadChildren: () => import('./_metronic/layout/layout.module').then((m) => m.LayoutModule),
  },
  {
    path: 'portfolio',
    loadChildren: () => import('./pages/portfolio/portfolio.module').then((m) => m.PortfolioModule),
  },
  {
    path: 'account-dashboard',
    loadChildren: () =>
      import('./pages/accounting/account-dashboard/account-dashboard.module').then(
        (m) => m.AccountDashboardModule,
      ),
  },
  {
    path: 'email-template',
    loadChildren: () =>
      import('./pages/email-template/email-template.module').then((m) => m.EmailTemplateModule),
  },
  {
    path: 'uploads',
    loadChildren: () => import('./pages/uploads/uploads.module').then((m) => m.UploadsModule),
  },

  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
